import { Integration } from '../../../../shared/interfaces/integration';
import { PipelineOverviewSetup } from './PipelineOverviewSetup';

export function PipelineOverviewV1SetupWrapper({ integration }: { integration: Integration }) {
  return (
    <div className='body-container h-100 w-100'>
      <PipelineOverviewSetup integration={integration} />
    </div>
  );
}
